export default {
  hero_label: 'Case Studies',
  hero_title: '導入事例',
  hero_subtitle: 'AIで現場の人を強くする。AIX JAPANが伴走した変革の記録。',
  cat_all: 'すべて',
  cat_consulting: 'AIコンサルティング',
  cat_dev: 'システム開発',
  cat_poc: 'PoC・検証',
  cat_product: '自社開発プロダクト',
  read_more: '事例を見る',
  back_to_list: '事例一覧へ戻る',
  prev_case: '前の事例',
  next_case: '次の事例',
  partner_badge: 'パートナー事例',
  meta_industry: '業種',
  meta_category: '支援形態',
  section_challenge: '課題',
  section_challenge_en: 'CHALLENGE',
  section_approach: '支援内容',
  section_approach_en: 'APPROACH',
  section_results: '成果',
  section_results_en: 'RESULTS',
  section_tools: '使用技術',
  note_label: '補足',
  cases: [
    {
      id: 1,
      provider: 'aix',
      partnerLabel: '',
      category: 'システム開発',
      industry: '印刷業',
      client: '印刷会社様',
      scale: '',
      title: '大容量カタログPDFを商品データへ自動構造化するAIシステム',
      summary: '100〜500MB級のカタログPDFをAIで解析し、商品データをCSVへ自動構造化。手作業の転記をなくし、本番環境で安定稼働しています。',
      challenge: [
        'カタログPDFに眠る商品データを、検索・活用できるデータとして取り出したい',
        '現場が迷わない簡単操作（アップロードするだけ・ログイン不要）が必須条件',
        'アクセス制御はIP制限で担保し、運用の手間を増やさない'
      ],
      approach: [
        'PDFをページ分割し、AIのマルチモーダル解析で「列名抽出 → ページ単位のCSV変換」を実行',
        'キュー処理と最大8並列のワーカーによる多段処理で、100〜500MB級の大容量PDFに対応',
        'ユーザーマニュアル・運用ドキュメントを整備し、お客様の環境へ引き継ぎまで実施'
      ],
      results: [
        '手作業によるカタログデータの転記・構造化作業を自動化',
        '本番環境で安定稼働中。お客様のクラウド環境へ引き継ぎ済み'
      ],
      tools: ['Google Gemini', 'AWS（ECS Fargate / Aurora / S3 / SQS / CloudFront+WAF）', 'Node.js', 'TypeScript', 'React'],
      note: '',
      image: '/assets/aix_case_01.jpg'
    },
    {
      id: 2,
      provider: 'aix',
      partnerLabel: '',
      category: 'システム開発',
      industry: '建設機械レンタル業',
      client: '建設機械レンタル会社様',
      scale: '従業員約100名',
      title: '取引先検索から見積作成まで。一体型AI営業支援システムの開発',
      summary: '取引先検索・見積作成・訪問計画・社内マニュアル検索を一体化したAIシステムを開発。内製化の仕組みまで組み込みました。',
      challenge: [
        'ベテランの経験頼みで、新人が取引先を調べるのに時間がかかる',
        '行動予定・見積作成が手作業で、業務が属人化している',
        'チャットと規定参照でツールが分かれ、使い分けの負担が大きい'
      ],
      approach: [
        '業務支援: 商品名から取引実績の多い業者を、電話番号・担当者付きで即表示',
        '営業支援: SFAのデータから最適な行動予定を提案し、見積のひな形を自動生成',
        '内製化支援: メール文面の変更や簡易開発をクライアントだけで行える仕組みを組み込み'
      ],
      results: [
        '取引先調査が、先輩への確認や手作業から検索数秒に短縮',
        '行動予定・見積作成を自動化し、属人化を解消',
        '文面変更などの軽微な開発を、外注せず自社で即対応できる体制に'
      ],
      tools: ['Azure OpenAI（学習させない構成）', 'RAG', 'クラウド'],
      note: '社外流出防止・学習しない仕様でセキュアに構築。提案段階から動くデモを提供し、完成イメージを共有しながら進めました。',
      image: '/assets/aix_case_02.jpg'
    },
    {
      id: 3,
      provider: 'aix',
      partnerLabel: '',
      category: 'AIコンサルティング',
      industry: '製造業（金型設計・製造）',
      client: '金型設計・製造会社様',
      scale: '従業員約50名',
      title: '現場が迷わず使える基盤づくりから始める、製造業のAI導入伴走',
      summary: 'ITに不慣れな現場でも迷わず使える業務基盤の整備から着手し、AI導入ロードマップの策定・提案まで伴走しています。',
      challenge: [
        'ITに不慣れな従業員が多く、迷わず使える業務基盤づくりがAI導入の前提条件',
        '紙ベースの作業や定型業務が残り、情報が分散している'
      ],
      approach: [
        '土台整備としてSlack導入を実施（チャンネル構成15ch・運用ルール策定・全社ポータル構築）',
        '紙ベースで行われていた作業や定型作業を、ワークフロー構築で効率化',
        '社内知識AI・検図自動判定・画像分析AIへ進むAI導入ロードマップを策定・提案'
      ],
      results: [
        'AI導入の受け皿となる社内コミュニケーション基盤の整備が完了',
        'AI時代に最適化された社内データベースを構築'
      ],
      tools: ['Slack', 'Microsoft 365（Loop / SharePoint / Entra ID）'],
      note: '基盤整備フェーズは完了。AI導入フェーズは社内知識AI・検図自動判定・画像分析AIを提案し、スコープ調整中です。',
      image: '/assets/aix_case_03.jpg'
    },
    {
      id: 4,
      provider: 'aix',
      partnerLabel: '',
      category: 'AIコンサルティング',
      industry: '製造業（航空宇宙関連）',
      client: '航空系製造業様',
      scale: '',
      title: 'オンプレミス型AI（RAG）による規格文書・技術ナレッジ検索の提案',
      summary: '規格文書と長年蓄積された社内技術データを対象に、機密を外部に出さないオンプレミス型のRAG検索基盤を、段階導入の設計とあわせて提案しています。',
      challenge: [
        '規格改訂のたびに、担当者が変更箇所を手動で確認し影響を調査している',
        '長年蓄積された技術データが活用しきれず、参照が担当者の記憶頼み',
        '機密文書を外部に出せず、オンプレミス前提の導入方法が定まらない'
      ],
      approach: [
        '規格影響分析: 改訂点の検出と、社内手順書への影響箇所の提示',
        '技術ナレッジ検索: 過去の設計などを対話形式で引き出せる仕組み',
        '段階導入設計: 体験フェーズ → PoC → 本番運用の3段階で、投資判断の材料を先に得られる進め方'
      ],
      results: [
        '規格改訂対応の工数を、半日〜数日から数分〜数十分へ短縮する道筋を提示',
        'ベテラン依存の暗黙知を、誰でも同じ品質で参照できる状態へ',
        '体験フェーズで判断材料を得てから本番投資へ進める設計により、導入の確度を向上'
      ],
      tools: ['オンプレミス構成のLLM', 'ベクトルDB', 'RAG'],
      note: '全処理を顧客環境内で完結させ、社外通信なしのセキュアな構成としています。',
      image: '/assets/aix_case_04.jpg'
    },
    {
      id: 5,
      provider: 'aix',
      partnerLabel: '',
      category: 'PoC・検証',
      industry: '製造業（部品製造）',
      client: '部品製造会社様',
      scale: '',
      title: 'フォーマットの揺れた品質帳票からのデータ抽出・逆引き検索PoC',
      summary: '書式がバラバラな品質確定書（Excel）から品番・インキ・材料情報を抽出し、「材料 → 品番」の逆引き検索を実証。汎用AIが苦手とする帳票の揺れを吸収しました。',
      challenge: [
        'インキ・材料の設計変更時に、影響を受ける品番の洗い出しが手作業頼み',
        '情報源はフォーマットの揺れた確定書のみで、汎用AIツールでは対応できなかった',
        '機密データを外部AIに送信しないクローズドな方式が条件'
      ],
      approach: [
        'ヒアリング・AIベンダー比較から課題を構造化し、検証設計 → PoC → 報告まで一気通貫で支援',
        'ヘッダ追従抽出・日本語正規化・コードパターン抽出で、フォーマット揺れ・列位置ズレ・多版シートを吸収',
        '完全ローカル処理で機密データの外部送信ゼロ。検索結果は該当箇所（ファイル／セル／原文）まで提示'
      ],
      results: [
        '対象9帳票すべてで抽出に成功。逆引き検索は全10クエリで再現率・適合率100%を達成',
        '生成AIが苦手とする帳票のフォーマット揺れを吸収し、業務課題をマスタ構築で解消する道筋を提示'
      ],
      tools: ['Python（Excel構造化抽出・日本語正規化・索引／検索）', 'クローズド環境・外部AI送信なし'],
      note: '無償PoCとして実施。評価を受け、有償後続（数千ファイルへのスケール・検索UI化・OCR対応）を提案中です。',
      image: '/assets/aix_case_05.jpg'
    },
    {
      id: 6,
      provider: 'aix',
      partnerLabel: '',
      category: 'システム開発',
      industry: 'マーケティング・広告',
      client: 'アフィリエイト事業会社様',
      scale: '',
      title: 'アフィリエイトデータ統合分析AIシステムの構想・設計支援',
      summary: '多種多様なアフィリエイトサービスと連携し、データ統合・分析・AIリコメンドを行うシステムを、構想段階から要求定義・基本設計まで支援しました。',
      challenge: [
        '100以上のサービスや基幹システムに散在するデータを連携し、定常業務を効率化したい',
        '大量のアフィリエイトデータが分析しきれず、施策の判断材料として活用できていない'
      ],
      approach: [
        'データの集約・分析・レポーティングを自動化し、施策やチャネルをAIがリコメンドする新たなマーケティングツールを企画',
        '構想段階から要求／要件定義、基本設計までを伴走支援',
        'ITに詳しくない担当者のイメージを言語化し、UIへ落とし込んで完成像を共有'
      ],
      results: [
        '定常業務の効率化により、2〜4人月程度の工数削減を見込む設計を確立',
        '分析しきれていなかったデータを集約・統合し、新たなサービス提供につなげる構想を具体化'
      ],
      tools: ['Next.js', 'React', 'TypeScript', 'Neon (PostgreSQL)', '各ASP API', 'Vercel'],
      note: '顧客の期待値を超えるアウトプットを目指し、担当者のイメージをUIに落とし込みながら進めた、顧客満足度の高い取り組みとなりました。',
      image: '/assets/aix_case_06.jpg'
    },
    {
      id: 7,
      provider: 'aix',
      partnerLabel: '',
      category: '自社開発プロダクト',
      industry: '全業種向け',
      client: '自社開発',
      scale: '',
      title: 'AI活用度診断システム — 組織のAI活用レベルを5観点で可視化',
      summary: '個人・組織のAI活用レベルを5つの観点で診断し、AIがパーソナライズされた改善アドバイスを自動生成するWebアプリケーションです。',
      challenge: [
        'AI導入を進めたくても、自社の現在地と課題が分からず、何から手を付けるべきか判断できない',
        '診断結果を研修やコンサルティングへつなげる入口が必要'
      ],
      approach: [
        '5観点の設問に回答すると、カテゴリ別で現状のレベルをチャートで可視化',
        '診断スコアとユーザータイプ（個人／組織）に応じて、LLMが改善アドバイスを動的に生成',
        '診断結果の保存・共有・メール送信に対応し、研修・コンサル提案の入口として機能'
      ],
      results: [
        'AI導入の現在地と課題が数値・チャートで即時に可視化され、組織のAI活用推進の起点に',
        '診断 → アドバイス → 研修・伴走支援へつながる自社サービスの入口ツールとして稼働'
      ],
      tools: ['Next.js', 'React', 'TypeScript', 'Supabase', 'OpenAI', 'Vercel'],
      note: '',
      image: '/assets/aix_case_07.jpg'
    },
    {
      id: 8,
      provider: 'aix',
      partnerLabel: '',
      category: '自社開発プロダクト',
      industry: '全業種向け',
      client: '自社開発',
      scale: '',
      title: 'ガイドAI — 現場社員のAI活用を伴走支援するChrome拡張機能',
      summary: 'ChatGPT・Claude・Gemini上で現場社員のAI活用を伴走支援し、機密情報の送信前チェックまで行うセキュリティガイド付きのChrome拡張機能です。',
      challenge: [
        'プロンプトの書き方が分からない現場社員でも「選ぶだけ」でAIを使いこなせるようにしたい',
        '機密情報・個人情報を社外AIへ送信してしまうリスクを減らしたい'
      ],
      approach: [
        '回答品質の低下を自動検知し、改善案を番号付きボタンで提示（選ぶだけで改善）',
        '電話番号・メールアドレス等の機密情報を送信前に検知・マスク（組織ごとのキーワード設定に対応）',
        'AI研修と連動し、研修で学んだことを職場でそのまま実践できる設計'
      ],
      results: [
        '研修で学んだことを職場で実践できる環境を提供し、AI活用の定着を支援',
        'ツールの使用を通じて、AIの活用方法やリテラシーが自然と身につく仕組みを実現'
      ],
      tools: ['Chrome拡張機能', 'Google Gemini API', 'Cloudflare Workers'],
      note: '将来的には利用状況の可視化・ガバナンスを担う管理ダッシュボードへ拡張予定です。',
      image: '/assets/aix_case_08.jpg'
    }
  ]
};
